import styled from 'styled-components';

export const StyledTrait = styled.div`
  position: relative;
  background: transparent;

  .shadow-maker {
    position: absolute;
    width: 300px;
    height: 100px;
    top: 20%;
    left: 10%;
    box-shadow: 0 0 200px 50px ${({ shadowcolor }) => shadowcolor};
  }

  .trait {
    position: relative;
    height: 150px;
    width: 350px;
    background-color: transparent;
    overflow: hidden;
  }

  .hexagon {
    position: absolute;
    left: -29%;
    width: 200%;
    height: 200%;
    background-color: ${({ color }) => color};
    transform-origin: 50% 50%;
    transform: rotate(45deg);
  }
  .content {
    text-transform: uppercase;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 10px 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    gap: 20px;
    font-size: 24px;
    font-weight: 700;

    img {
      height: 60%;
    }
  }
`;

